import React, { useState } from 'react';
import Image from 'next/image';
import cn from 'classnames';

import Card from '../Card/Card';

import styles from './TravelRecommendationBlock.module.scss';
import Props from './TravelRecommendationBlock.props';

const TravelRecommendationBlock = ({ title, image, content, className }: Props) => {
  const [dynamicWidth, setDynamicWidth] = useState(0);
  const height = 60;

  const handleDynamicWidth = (e: HTMLImageElement) => {
    setDynamicWidth((e.naturalWidth / e.naturalHeight) * height);
  };

  return (
    <Card className={cn(styles.Wrapper, className)}>
      <div className={styles.TravelRecommendationBlock}>
        {!!title && <p className={cn('h4', styles.Title)}> {title}</p>}
        {!!image && (
          <Image
            src={image}
            alt=""
            quality={60}
            className={styles.Image}
            height={height}
            width={dynamicWidth}
            onLoad={(e) => {
              handleDynamicWidth(e.target as HTMLImageElement);
            }}
          />
        )}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </Card>
  );
};

export default TravelRecommendationBlock;
